{
  "nl": {
    "locale_field": {
      "fallback_tooltip": "Wanneer er geen tekst ingevoerd is voor deze taal, wordt deze standaardtekst als terugvaloptie gebruikt."
    }
  }
}
